export const INTERNATIONAL_SHIPMENTS_SCOPE = 'INTERNATIONAL'

// Volumen comprometido aplicable a un producto para elegir su tramo de descuento.
// Los productos internacionales usan el volumen internacional (si está declarado, > 0);
// en cualquier otro caso se usa el volumen nacional (fallback seguro, sin regresión).
// Mismo criterio que el back en Offer.committedShipmentsFor.
export const getCommittedDeliveriesForProduct = (
  product,
  committedDeliveries,
  internationalDeliveries,
) =>
  product.shipmentsScope === INTERNATIONAL_SHIPMENTS_SCOPE && Number(internationalDeliveries) > 0
    ? internationalDeliveries
    : committedDeliveries

export const getZoneDiscountRatesOnCommitedDeliveries = (zone, numDeliveries) => {
  const discount =
    zone.discounts.find(discount => discount.shippingUntil >= numDeliveries) ??
    zone.discounts[zone.discounts.length - 1];

  return {
    stdDiscountRate: discount.stdDiscountRate,
    maxDiscountRate: discount.maxDiscountRate,
  };
};

export const getSelectedWeightsPricesList = (pricesList, currentWeightIdList) => {
  if (!Array.isArray(pricesList) || !Array.isArray(currentWeightIdList)) {
    return [];
  }

  return currentWeightIdList.map(weightId => {
    const found = pricesList.find(item => item.id === weightId);
    if (!found) {
      return { id: weightId, price: 0 };
    }
    return found;
  });
};

export const getPricesListOnDiscount = (pricesList = [], discount = 0, fixedPrice = 0) => {
  return pricesList.map(item => {
    if (!item || typeof item.price !== 'number') {
      return { id: 'N/A', price: '0.00' };
    }
    return {
      ...item,
      price: getDiscountedPrice(item.price, discount, fixedPrice),
    };
  });
};

export const getDiscountedPrice = (defaultPrice, discount, fixedPrice = 0) => {
  const result = (defaultPrice - fixedPrice) * (1 - discount) + fixedPrice;
  return result.toFixed(2);
};

export const normalizeProductListPrices = (productList) => {
  if (!Array.isArray(productList)) return productList;
  
  return productList.map(product => ({
    ...product,
    zoneList: product.zoneList?.map(zone => ({
      ...zone,
      additionalKgValue: zone.additionalKgValue !== undefined && zone.additionalKgValue !== null
        ? Number(Number(zone.additionalKgValue).toFixed(2))
        : zone.additionalKgValue,
    })) || [],
  }));
};
